// 字节转换
export const bytesToSize = (bytes) => {
  if (bytes === 0) return '0 B'
  var k = 1024
  var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  var i = Math.floor(Math.log(bytes) / Math.log(k)) // return (bytes / Math.pow(k, i)) + ' ' + sizes[i];
  // return (bytes / Math.pow(k, i)).toPrecision(3) + " " + sizes[i]; //toPrecision(3) 后面保留两位小数，如1.00GB
  return (
    (Math.floor((bytes / Math.pow(k, i)) * 100) / 100).toFixed(2) +
    ' ' +
    sizes[i]
  )
}
